import React, { useEffect } from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import EntityEditor from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetEntity/EntityEditor';
import PeriodEditor from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetEntity/PeriodEditor';
import { BackNextButtons } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/common';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING_BUDGET } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useAppSelector, useHistory } from 'src/utils/Hooks';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch } from 'react-redux';
import { setPlatform } from 'src/store/modules/adManager/adBudgetEditor/actions';
import _get from 'lodash/get';
import { getAllocationMetric } from 'src/store/modules/adManager/adBudgetEditor/operations';

const BudgetEntity = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const adPlatforms = useAppSelector((state) => state.adPlatforms);
  const retailerId = useAppSelector((state) => state?.retailer?.id);
  const { queryParams } = useAppSelector((state) => state.app);
  const { searchParams } = queryParams;
  const { mainEntity } = useAppSelector((state) => state.entityService);

  const { hashId } = mainEntity;
  const selectedEntity = useAppSelector((state) => state.adBudgetEditor.entity);
  const selectTimeline = useAppSelector((state) => state.adBudgetEditor.timeline);

  const canMoveNext = !_isEmpty(selectedEntity) && !!selectTimeline;

  useEffect(() => {
    dispatch(getAllocationMetric());
  }, [dispatch]);

  useEffect(() => {
    const selectedPlatform: any = adPlatforms.find((item) => +item?.extendedAttributes?.retailerId === +retailerId);

    dispatch(
      setPlatform({
        platformId: selectedPlatform?.id,
        platformName: selectedPlatform?.name,
        timeZone: _get(selectedPlatform, ['extendedAttributes', 'processInTimezone'], '')
      })
    );
  }, [retailerId, adPlatforms, dispatch]);

  const onNextClick = () => {
    history.push(`/client/${hashId}${searchParams}&tab=advertising&subtab=budgetAllocation`);
  };
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING_BUDGET}>
        <PeriodEditor />
        <EntityEditor />
        <BackNextButtons canMoveNext={canMoveNext} onNextClick={onNextClick} />
      </Flex>
    </BasePageContainer>
  );
};

export default BudgetEntity;
